export default __webpack_public_path__ + "static/media/awardsBg1.6a1ea3d1.png";